import React, { useState } from "react";
import PropTypes from "prop-types";

import { TooltipContainer } from "./style";

const Tooltip = (props) => {
    const [id] = useState(Math.round(Math.random() * 1000000));

    const textContainer = document.getElementById(`tooltip-${id}`);
    const textWidth = textContainer ? textContainer.clientWidth : 0;

    return (
        <TooltipContainer textWidth={textWidth}>
            {props.children}
            <div className="tooltiptext" id={`tooltip-${id}`}>
                {props.text}
            </div>
        </TooltipContainer>
    );
};

Tooltip.propTypes = {
    children: PropTypes.any,
    text: PropTypes.any,
};

export default Tooltip;
